import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';
import MemberExecutiveSummary from 'models/ExecutiveSummaryMember';

const MEMBERS_TAG = 'ExecutiveSummaryMembers';

export const executiveSummaryMembersApi = createApi({
  reducerPath: 'executiveSummaryMembersApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/executive-summary-members/',
  }),
  tagTypes: [MEMBERS_TAG],
  endpoints: builder => ({
    getMembers: builder.query({
      query: params => ({ url: '', params }),
      providesTags: [MEMBERS_TAG],
      transformResponse: response => response.map(member => new MemberExecutiveSummary(member)),
    }),
    createMember: builder.mutation({
      query: data => ({
        url: '',
        method: 'POST',
        data,
      }),
      invalidatesTags: [MEMBERS_TAG],
    }),
    updateMember: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${id}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [MEMBERS_TAG],
    }),
    uploadMemberImage: builder.mutation({
      query: ({ id, field, image }) => {
        const formData = new FormData();
        formData.append(field, image);
        return {
          url: `${id}/`,
          method: 'PATCH',
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        };
      },
      invalidatesTags: [MEMBERS_TAG],
    }),
    deleteMember: builder.mutation({
      query: ({ id }) => ({
        url: `${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [MEMBERS_TAG],
    }),
  }),
});

export const {
  useGetMembersQuery,
  useCreateMemberMutation,
  useUpdateMemberMutation,
  useUploadMemberImageMutation,
  useDeleteMemberMutation,
} = executiveSummaryMembersApi;
